import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SpinnerService {

  constructor() { }

  isActive : boolean = false;

  show(){
    this.isActive = true;
  }
  
  hide(){
    this.isActive = false;
  }
  
}
